import { createStore } from 'zustand';
import * as Interfaces from '@/components/staffer/AssignmentsBasedGradesTable/types';
import { ISubmission, IAssignment } from '@/components/interfaces';
import {
  IClassroom,
  ILesson,
  IUnit,
  LowScoreSettings,
  IStudent,
} from '@/components/staffer/AssignmentsBasedGradesTable/types';
import { StudentRowDataType } from '../utils';

export interface AssignmentsBasedGradesTableProps {
  classroom: IClassroom,
  lastViewed: string,
  lesson: ILesson,
  lowScoresSettings: LowScoreSettings,
  programId: number,
  student: IStudent,
  unit: IUnit,
}

interface GradesTableStoreVariables {
  assignments: IAssignment[];
  classroom: Interfaces.IClassroom;
  isLoading: boolean;
  isLoadingAssignments: boolean;
  lastViewed: string,
  lesson: Interfaces.ILesson;
  lowScoresSettings: LowScoreSettings
  programId: number;
  submissions: ISubmission[];
  student: IStudent
  tableData: StudentRowDataType[];
  unit: Interfaces.IUnit;
}

export interface UseGradesTableState extends GradesTableStoreVariables {
  setStore: (nextState: Partial<GradesTableStoreVariables>) => void;
}

const createGradesTableStore = (props: AssignmentsBasedGradesTableProps) => createStore<UseGradesTableState>()(set => ({
  ...props,
  isLoading: true,
  isLoadingAssignments: true,
  assignments: [],
  submissions: [],
  tableData: [],
  setStore: nextState => set(prevState => ({ ...prevState, ...nextState })),
}));

export default createGradesTableStore;
